/**
 * @module geo/middleware
 */
import { Action } from "redux";
import { Epic } from "redux-observable";
import { Observable, Observer } from "rxjs";
import { Action as ActionFsa, isType } from "typescript-fsa";

import {
  initApplicationAsyncCreator,
  initApplicationCreator,
  GEO_API_PROXY_READYCreator
} from "../actions/creators";
import { registerExtensionCreator } from "../actions/creators/register.extension.creator";
import busService from "../bus";
import { ComponentInstanceLoader, Component } from "../components";
import { INIT_APP } from "../payload/facade";
import { Acknowledged } from "../payload/response/acknowledged";
import { AppStore } from "../store/app";
import { ExtensionProperties } from "../types/extensions";
import { ComponentOptions } from "../types/component";
import { GEO_API_PROXY_READY } from "../payload/proxy/GEO_API_PROXY_READY";

/**
 * @private
 * @param {ActionsObservable<Action>} action$
 * @param {MiddlewareAPI<AppStore>} store
 * @param {string} uid
 * @returns {any}
 */
export const initialiseEpic: Epic<Action, AppStore> = (action$, store, uid: string) =>
  action$
    .filter(action => isType(action, initApplicationCreator))
    .mergeMap(action => {
      const actionFsa = action as ActionFsa<INIT_APP>;
      const geoBusApp = busService.geoBus.getRegisteredApp(
        store.getState().uid
      );

      const stack = geoBusApp.inited ? Observable.of(geoBusApp.isReady) : Observable.from(geoBusApp.promiseInit);

      return stack
        .map((readyState: GEO_API_PROXY_READY) =>
          Observable.create((observer: Observer<Acknowledged>) => {
            if (actionFsa.payload.components) {
              for (const i in actionFsa.payload.components) {

                if ("string" !== typeof i || !actionFsa.payload.components[i] || undefined === actionFsa.payload.components[i].extensions) {
                  continue;
                }
                const comp: ComponentOptions = actionFsa.payload.components[i];
                const extensions = actionFsa.payload.components[i].extensions as ExtensionProperties[];

                if (extensions.length > 0) {
                  const componentInst: Component = ComponentInstanceLoader.getInstance(i, uid, comp);
                  for (let j = 0; j < extensions.length; j++) {
                    if (undefined !== extensions[j]) {
                      const ext = componentInst.buildExtension(extensions[j]);
                      observer.next(
                        busService.geoBusSync.send<Acknowledged>(
                          registerExtensionCreator.type,
                          ext,
                          uid
                        )
                      );
                    }
                  }
                }
              }
            }
            observer.complete();
          }).concat(
            Observable.fromPromise(
              busService.geoBus.send<Acknowledged>(
                initApplicationAsyncCreator.type,
                actionFsa.payload,
                uid
              )
            )
          )
        )
        .flatMap((results: any) => results)
        .map(() => {
          return initApplicationAsyncCreator.done({
            result: busService.geoBus.getRegisteredApp(store.getState().uid).isReady,
            params: actionFsa.payload
          });
        })
        .catch((error: any) =>
          Observable.of(
            initApplicationAsyncCreator.failed({
              params: actionFsa.payload,
              error
            })
          )
        );
    });
